// 获取条件使用的formDesign 里面的ids
export const getconditionsUseData = (data) => {
  let result = [];
  let rootArr = [data];
  let i = 0;
  while (rootArr.length != 0) {
    i++;
    const item = rootArr[0];
    rootArr.shift();
    // 如果是路由节点的话，先把branchList 放进rootArr里面 如果有child 就把child 放入rootArr
    if (item.nodeType == 5) {
      rootArr = rootArr.concat(item.branchList);
      if (item.child && Object.prototype.toString.call(item.child) === '[object Object]') {
        rootArr = rootArr.concat(item.child);
      }
    } else if (item.nodeType == 4) {
      // 如果是条件节点的话，就把条件存一下
      if (item.boolSpelExpressionList && Array.isArray(item.boolSpelExpressionList) && item.boolSpelExpressionList.length > 0) {
        result = result.concat(item.boolSpelExpressionList);
      }
      if (item.child && Object.prototype.toString.call(item.child) === '[object Object]') {
        rootArr = rootArr.concat(item.child);
      }
    } else {
      if (item.child && Object.prototype.toString.call(item.child) === '[object Object]') {
        console.log('我竟然没执行');
        rootArr = rootArr.concat(item.child);
        console.log('rootArr', rootArr);
      }
    }
  };
  const keys = [];
  result.forEach(itemArr => {
    if (Array.isArray(itemArr)) {
      itemArr.forEach(item => {
        keys.push(item.keys);
      });
    }
  });
  return [...new Set(keys)];
};
